import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Loader2, Heart } from "lucide-react";
import { mySavedJobs } from "@/lib/jobsApi";
import ErrorState from "@/pages/jobs/ErrorState";
import { formatNZD } from "@/lib/format";

export default function JobSavedPage() {
  const q = useQuery({ queryKey: ["my-saved-jobs"], queryFn: mySavedJobs });
  // Real backend returns { jobs: [], total: 0 } — keep `listings` as a
  // defensive fallback in case the API layer is ever normalised.
  const rows = q.data?.jobs || q.data?.listings || [];
  return (
    <div className="max-w-4xl mx-auto px-4 md:px-8 py-8 md:py-12">
      <h1 className="font-display text-3xl font-black text-slate-900" data-testid="saved-jobs-title">Saved jobs</h1>
      <p className="text-sm text-slate-500 mt-1">Tap the heart on any job listing to save it here.</p>
      <ul className="mt-6 space-y-3" data-testid="saved-jobs-list">
        {q.isLoading && <li className="text-slate-400"><Loader2 className="inline w-4 h-4 animate-spin" /> Loading…</li>}
        {q.isError && <li><ErrorState onRetry={() => q.refetch()} /></li>}
        {!q.isLoading && !q.isError && !rows.length && <li className="text-slate-500 text-sm">No saved jobs yet.</li>}
        {rows.map((l) => (
          <li key={l.id} data-testid={`saved-job-${l.id}`} className="rounded-2xl bg-white border border-soft p-4 md:p-5 flex items-center gap-4">
            <Heart className="w-5 h-5 text-red-500 fill-red-500 shrink-0" />
            <div className="flex-1 min-w-0">
              <Link to={`/ad/${l.id}`} className="font-display font-bold text-slate-900 hover:text-[color:var(--brand-blue)]">{l.title}</Link>
              <div className="text-xs text-slate-500 mt-0.5">{l.attributes?.Salary || (l.price ? formatNZD(l.price) : "On application")}{l.city ? ` · ${l.city}` : ""}</div>
            </div>
            <span className="text-[10px] text-slate-400">Saved {new Date(l.saved_at).toLocaleDateString("en-NZ")}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
